// src/hooks/useClients.js
import { useEffect, useState } from "react";
import { getClients } from "@/services/clients.service";

function normalizeClientImage(image) {
  if (!image || typeof image !== "string") return null;

  if (image.startsWith("http")) return image;

  if (image.startsWith("public/")) {
    return `https://www.programshouse.com/hr/${image}`;
  }

  return `https://www.programshouse.com/hr/public/${image}`;
}

export function useClients() {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function fetchClients() {
      try {
        setLoading(true);
        setError(null);

        const result = await getClients();

        const clients =
          Array.isArray(result)
            ? result
            : Array.isArray(result?.data)
              ? result.data
              : Array.isArray(result?.data?.data)
                ? result.data.data
                : [];

        const formattedLogos = clients
          .map((item) =>
            normalizeClientImage(
              item?.image ||
              item?.logo ||
              item?.logo_url ||
              item?.image_url
            )
          )
          .filter(Boolean);

        if (active) {
          setLogos(formattedLogos);
        }
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to load client logos"
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    fetchClients();

    return () => {
      active = false;
    };
  }, []);

  return {
    logos,
    loading,
    error,
  };
}